import * as React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cn } from '@/hen-ui/utils';
import { textVariants, type TextVariantProps } from './text.variants';

export interface TextProps
  extends Omit<React.HTMLAttributes<HTMLElement>, 'color'>,
    TextVariantProps {
  asChild?: boolean;
  tag?:
    | 'p'
    | 'b'
    | 'em'
    | 'i'
    | 'small'
    | 'strong'
    | 'sub'
    | 'sup'
    | 'ins'
    | 'del'
    | 'mark'
    | 'span';
  variant?: 'd1' | 'd2' | 'd3' | 'b1' | 'b2' | 'b3' | 'b4' | 'b5' | 'l1' | 'l2';
  children: React.ReactNode;
}

export const Text = React.forwardRef<HTMLElement, TextProps>(
  (
    {
      className,
      tag = 'p',
      variant = 'b4',
      color,
      align,
      weight,
      asChild = false,
      children,
      ...props
    },
    ref,
  ) => {
    const Tag = tag;
    const Comp: React.ElementType = asChild ? Slot : Tag;
    return (
      <Comp
        ref={ref}
        className={cn(
          textVariants({ variant, color, align, weight }),
          className,
        )}
        {...props}
      >
        {children}
      </Comp>
    );
  },
);

Text.displayName = 'Text';
